import { render, staticRenderFns } from "./KwicHeader.vue?vue&type=template&id=ec0cd68a&scoped=true&"
import script from "./KwicHeader.vue?vue&type=script&lang=js&"
export * from "./KwicHeader.vue?vue&type=script&lang=js&"
import style0 from "./KwicHeader.vue?vue&type=style&index=0&id=ec0cd68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_css-loader@3.6.0_lodash@4.17.21_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0cd68a",
  null
  
)

export default component.exports